export const getPathWithoutLocale = pathname => {
  return pathname.replace('/en', '');
}

export const getLocale = pathname => {
  return pathname.includes('/en') ? 'en' : 'jp';
}
